<ion-list-header>
	<ion-label>
		Select Order
	</ion-label>
	<ion-chip
		*ngIf="hasChangeOrderListener && showChangeOrder && selectedOrder"
		class="change-order-chip"
		(click)="changeOrder.emit()"
	>
		Change Order
	</ion-chip>
</ion-list-header>

<ion-item *ngIf="(!orders || orders.length === 0)">
	<ion-text class="validation-text validation-text--info">
		Patient has no orders to select.
	</ion-text>
</ion-item>

<ng-container *ngIf="hasActiveOrders(orders)">
	<div class="order-container">
			<div *ngFor="let order of orders; let i = index" size="12" size-sm="4">
				<div class="order"
				     [ngClass]="{ 'selected': selectedOrder === order }"
				     (click)="selectOrder($event, order)">
					<div class="order__title">
						<div>{{ displayDate(order.startDate) }}</div>
						<ion-chip *ngIf="getStandingStatus(order)" size="small">
							{{ getStandingStatus(order) }}
						</ion-chip>
					</div>

					<ul class="order__details">
						<li *ngFor="let detail of getOrderDetails(order)">{{ detail }}</li>
					</ul>
				</div>
			</div>
	</div>
</ng-container>

<ng-container *ngIf="hasActiveNPOOrder">
	<ion-text  class="validation-text validation-text--warning">
		<img src="assets/imgs/icon-exclamation-point.png" class="icon">
		Patient has an active NPO order in place.
	</ion-text>
</ng-container>

<ion-list-header heading="secondary">
	<ion-label>
		Instructions
	</ion-label>
</ion-list-header>

<p>{{ selectedOrder?.instructions || "None" }}</p>

<ng-container *ngIf="_validationResults2 && !isValidOrderMatch(_validationResults2)">
	<ion-text *ngIf="!hasValidOrderFulfillment(_validationResults2)" class="validation-text validation-text--warning">
		<img src="assets/imgs/icon-exclamation-point.png" class="icon" alt="">
		The contents of the bottle do not match the selected order.
	</ion-text>
</ng-container>

<ng-container *ngIf="!isCalorieMatch()">
	<ion-text  class="validation-text validation-text--warning">
		<img src="assets/imgs/icon-exclamation-point.png" class="icon" alt="">
		The caloric density does not match the order.
	</ion-text>
</ng-container>
